import validationRules from "../validationRules";
validationRules.register("url", function (record, fieldMetadataMap, fieldName, t) {
    var value = record[fieldName];
    if (!value) {
        return true;
    }
    var er = new RegExp("^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$", "i");
    if (value.length === 0 || er.test(value)) {
        return true;
    }
    return "should be a url.";
});
